import { useQuery } from "@tanstack/react-query";
import { useRawInitData } from "@tma.js/sdk-react";
import invariant from "tiny-invariant";

import { QueryOptions } from "shared/types";

type Params = {
  userId: number | undefined;
};

type Response = {
  success: boolean;
  telegramId: number;
  activityScore: string;
  sybilScore: string;
};

export const useBlumScoreQuery = <TData = Response>(
  params: Params,
  options?: QueryOptions<Response, unknown, TData>
) => {
  const { userId } = params;
  const initData = useRawInitData();
  return useQuery({
    queryKey: ["blum-score", userId],
    queryFn: async () => {
      invariant(userId, "userId is undefined");
      const response = await fetch(
        `${import.meta.env.VITE_BLUM_GUARDIAN_URL}/api/blum-score`,
        {
          method: "POST",
          body: JSON.stringify({ initData }),
        }
      );
      const data: Response = await response.json();

      return data;
    },
    ...options,
    enabled: Boolean(userId && (options?.enabled ?? true)),
  });
};
